
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from "@/components/ui/tooltip";

import LandingPage from "@/pages/LandingPage";
import Index from "@/pages/Index";
import FormPage from "@/pages/FormPage";
import Reports from "@/pages/Reports";
import TeacherReportsPage from "@/pages/TeacherReportsPage";
import ReportDetail from "@/pages/ReportDetail";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Profile from "@/pages/Profile";
import NotFound from "@/pages/NotFound";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminWorksheetCheck from "@/pages/AdminWorksheetCheck";
import AdminLogs from "@/pages/AdminLogs";
import TeacherSalaryPage from "@/pages/TeacherSalaryPage";
import SpecialClass from "@/pages/SpecialClass";
import SpecialClassFormPage from "@/pages/SpecialClassFormPage";
import TeacherSchedulePage from "@/pages/TeacherSchedulePage";
import AdminStudentListPage from "@/pages/AdminStudentListPage";

import AdminProtectedRoute from "@/components/auth/AdminProtectedRoute";
import { AuthProvider } from "@/context/auth/AuthProvider";
import MainLayout from "@/components/layout/MainLayout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

const queryClient = new QueryClient();

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route element={<MainLayout />}>
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/teacher-reports" element={<Reports />} />
                  <Route path="/form" element={<FormPage />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/reports/:id" element={<ReportDetail />} />
                  <Route path="/salary" element={<TeacherSalaryPage />} />
                  <Route path="/special-class" element={<SpecialClassFormPage />} />
                  <Route path="/special-class/form" element={<SpecialClassFormPage />} />
                  <Route path="/teacher-schedule" element={<TeacherSchedulePage />} />
                </Route>
              </Route>
              <Route path="/public-form" element={<Index />} />
              <Route path="/form" element={<FormPage />} />
              <Route path="/reports" element={<TeacherReportsPage />} />
              <Route path="/reports/:id" element={<ReportDetail />} />
              
              <Route path="/profile" element={<Profile />} />
              <Route path="/special-class" element={<SpecialClass />} />
              
              {/* Admin Routes */}
              <Route element={<AdminProtectedRoute />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/worksheet-check" element={<AdminWorksheetCheck />} />
                <Route path="/admin/logs" element={<AdminLogs />} />
                <Route path="/admin/students" element={<AdminStudentListPage />} />
                <Route path="/teacher/salary" element={<TeacherSalaryPage />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster />
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
